<template>
    <v-app>
        <v-container fluid fill-height>
            <v-layout justify-center align-center>
                <v-alert type="error"
                    >A critical error has occurred. Please contact customer support at: support@swyftsites.com
                </v-alert>
            </v-layout>
        </v-container>
    </v-app>
</template>
<script>
import store from '../store/store';
import router from '../router/routes';

export default {
    name: 'Error',

    data() {
        return {
            hbTimer: false,
            hbTime: 10000,
        };
    },

    mounted() {
        this.checkHeartbeat();
    },

    methods: {
        checkHeartbeat() {
            this.dispatchCheck();
        },

        heartbeatTimer() {
            clearInterval(this.hbTimer);
            this.dispatchCheck();
        },

        dispatchCheck() {
            store.dispatch('heartbeat').then((response) => {
                if (response === 200) {
                    clearInterval(this.hbTimer);
                    router.push({ name: 'Dashboard' });
                } else {
                    this.hbTimer = setInterval(this.heartbeatTimer, this.hbTime);
                }
            });
        },
    },

    destroyed() {
        clearInterval(this.hbTimer);
    },
};
</script>
